import React from 'react';

const BlockUptimeSquares = ({ blocks }) => {
  return (
    <div className="flex flex-wrap gap-1">
      {blocks.map((block, index) => (
        <div
          key={index}
          className={`w-4 h-4 ${
            block.signed ? 'bg-green-500' : 'bg-red-500'
          } rounded`}
          title={`Block ${block.height}: ${block.signed ? 'Signed' : 'Missed'}`}
        />
      ))}
    </div>
  );
};

export default BlockUptimeSquares;